import { Component, OnInit } from '@angular/core';
import { PersistenceService } from '@app/_services/persistence.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'tenant-index',
  templateUrl: './tenant.component.html',
  styleUrls: ['./tenant.component.scss']
})
export class TenantComponent implements OnInit {

  constructor(
    public translate: TranslateService,
    public persistenceService: PersistenceService,
  ) {
    // this language will be used as a fallback when a translation isn't found in the current language
    //translate.setDefaultLang('fi');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use(persistenceService.getLang());
  }

  // Basically reloads the page on inactive tabs or windows when changes detected in localStorage/currentUser
  //@HostListener('window:storage', ['$event']) handleStorageChange(event: StorageEvent) {
  //  if (event.key === 'currentUser') {
  //    this.authService.setCurrentUserFromStorage();
  //    this.router.navigate(['login']);
  //  }
  //}

  ngOnInit() {
  }

}
